<!-- 
  客户流失原因
 -->

<template>
  <div class="lose-because">
    <el-dialog title="客户阶段变更" 
      :visible.sync="dialogVisible" 
      :modal-append-to-body="false"
      :before-close="cancelDialog"
      top="20%">
      <div class="content">
        <div class="hint"><i class="el-icon-warning"></i>确认跳转到<span class="name"> 流失 </span>阶段吗？</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px">
          <el-form-item label=" " prop="cause">
            <el-select v-model="ruleForm.cause" placeholder="请选择流失原因（必填）">
              <el-option v-for="loseCause in loseCauseArray" :key="loseCause.key" :label="loseCause.value" :value="loseCause.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input type="textarea" v-model="ruleForm.memo" placeholder="流失备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="cancelDialog">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  created () {
    this.getLoseCause()
  },
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        memo: '',
        cause: ''
      },
      loseCauseArray: [], // 流失原因
      rules: {
        cause: { type: 'string', required: true, message: '请选择流失原因', trigger: 'change' }
      }
    }
  },
  props: {
    customerId: {
      type: Number
    },
    templateId: {
      default: ''
    }
  },
  computed: {
  },
  methods: {
    // 得到客户流失原因
    getLoseCause () {
      let url = `/dataDictionaryApi/getNowSets.html`
      let params = {
        type: 21,
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.loseCauseArray = data.result
        this.dialogVisible = true
      })
    },
    // 关闭弹框
    cancelDialog () {
      this.dialogVisible = false
      this.$emit('close')
    },
    // 提交数据
    submitForm (formName) {
      this.$refs[ formName ].validate((valid) => {
        if (valid) {
          this.changeStage()
        }
      })
    },
    // 改变客户阶段为流失
    changeStage () {
      let url = `/customerStage/changeStage.html`
      let params = {
        customerId: this.customerId,
        stageType: 2,
        reasonId: this.ruleForm.cause,
        memo: this.ruleForm.memo
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.$emit('refresh')
        this.cancelDialog()
      })
    }
  }
}
</script>
<style lang="less">
</style>
<style lang="less" scoped>
.lose-because {
  .el-select, .el-textarea{
    width: 80%;
  }   
  .content {
    padding-left: 40px;
    .hint {
      font-size: 14px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .name {
        color: #ff7c35;
      }
      .el-icon-warning {
        font-size: 26px;
        color: #e6a23c;
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// lose-because.vue?b6ee2f56